(function () {
  'use strict';

  if (window.__pbGlobalGeoPopupInitialized) return;
  window.__pbGlobalGeoPopupInitialized = true;

  const CONFIG = {
    workerBaseUrl:
      'https://playbear-global-geo-router.rough-cell-5947.workers.dev',

    brazilUrl:
      'https://playbear.com.br/?utm_source=playbear_global&utm_medium=owned&utm_campaign=pb_global_to_br_2026&utm_content=geo_popup',

    globalChoiceDays: 1
  };

  const KEYS = {
    visitorId: 'pb_geo_visitor_id',
    globalChoiceUntil: 'pb_geo_global_choice_until',
    sessionId: 'pb_geo_session_id',
    popupShown: 'pb_geo_popup_shown'
  };

  function makeId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return (
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2) +
      '-' +
      Math.random().toString(36).slice(2)
    );
  }

  function getVisitorId() {
    try {
      let id = localStorage.getItem(KEYS.visitorId);

      if (!id) {
        id = makeId();
        localStorage.setItem(KEYS.visitorId, id);
      }

      return id;
    } catch (e) {
      return makeId();
    }
  }

  function getSessionId() {
    try {
      let id = sessionStorage.getItem(KEYS.sessionId);

      if (!id) {
        id = makeId();
        sessionStorage.setItem(KEYS.sessionId, id);
      }

      return id;
    } catch (e) {
      return makeId();
    }
  }

  function hasChosenGlobalRecently() {
    try {
      const value = localStorage.getItem(KEYS.globalChoiceUntil);

      if (!value) return false;

      const until = Number(value);

      if (!Number.isFinite(until)) {
        localStorage.removeItem(KEYS.globalChoiceUntil);
        return false;
      }

      if (Date.now() >= until) {
        localStorage.removeItem(KEYS.globalChoiceUntil);
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  function rememberGlobalChoice() {
    try {
      const milliseconds =
        CONFIG.globalChoiceDays * 24 * 60 * 60 * 1000;

      localStorage.setItem(
        KEYS.globalChoiceUntil,
        String(Date.now() + milliseconds)
      );
    } catch (e) {
      // Ignore storage errors
    }
  }

  function popupAlreadyShownThisSession() {
    try {
      return sessionStorage.getItem(KEYS.popupShown) === '1';
    } catch (e) {
      return false;
    }
  }

  function markPopupShownThisSession() {
    try {
      sessionStorage.setItem(KEYS.popupShown, '1');
    } catch (e) {
      // Ignore storage errors
    }
  }

  function getPagePath() {
    return (
      window.location.pathname +
      window.location.search
    ).slice(0, 500);
  }

  async function trackEvent(eventType) {
    try {
      const response = await fetch(
        CONFIG.workerBaseUrl + '/event',
        {
          method: 'POST',
          mode: 'cors',
          cache: 'no-store',
          keepalive: true,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            event_type: eventType,
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            page_path: getPagePath()
          })
        }
      );

      return response.ok;
    } catch (e) {
      return false;
    }
  }

  async function trackBeforeNavigation(eventType) {
    await Promise.race([
      trackEvent(eventType),
      new Promise(function (resolve) {
        setTimeout(resolve, 600);
      })
    ]);
  }

  function closePopup() {
    const popup = document.getElementById('pb-geo-popup');

    if (popup) {
      popup.classList.remove('pb-geo-popup--visible');

      window.setTimeout(function () {
        popup.hidden = true;
      }, 180);
    }

    document.documentElement.classList.remove(
      'pb-geo-popup-open'
    );
  }

  function showPopup(isTestMode) {
    const popup = document.getElementById('pb-geo-popup');

    if (!popup) return;

    markPopupShownThisSession();

    popup.hidden = false;

    window.requestAnimationFrame(function () {
      popup.classList.add('pb-geo-popup--visible');
    });

    document.documentElement.classList.add(
      'pb-geo-popup-open'
    );

    if (!isTestMode) {
      trackEvent('br_popup_shown');
    }
  }

  function bindPopupActions(isTestMode) {
    const brazilButton =
      document.getElementById('pb-geo-go-brazil');

    const globalButton =
      document.getElementById('pb-geo-stay-global');

    const closeButton =
      document.getElementById('pb-geo-close');

    if (brazilButton) {
      brazilButton.addEventListener(
        'click',
        async function () {
          brazilButton.disabled = true;

          if (!isTestMode) {
            await trackBeforeNavigation(
              'br_redirect_click'
            );
          }

          window.location.assign(CONFIG.brazilUrl);
        }
      );
    }

    async function stayGlobal() {
      rememberGlobalChoice();

      if (!isTestMode) {
        trackEvent('br_stay_global');
      }

      closePopup();
    }

    if (globalButton) {
      globalButton.addEventListener(
        'click',
        stayGlobal
      );
    }

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        stayGlobal
      );
    }
  }

  async function init() {
    /*
     * Test mode:
     *
     * Add ?pb_geo_test=br to any Global URL.
     * It forces the popup to display but DOES NOT
     * write test events into D1.
     */
    const params =
      new URLSearchParams(window.location.search);

    const isTestMode =
      params.get('pb_geo_test') === 'br';

    bindPopupActions(isTestMode);

    if (isTestMode) {
      showPopup(true);
      return;
    }

    /*
     * Respect a customer's explicit decision
     * to stay on Global for 30 days.
     */
    if (hasChosenGlobalRecently()) {
      return;
    }

    /*
     * Don't repeatedly show the popup
     * during the same browser session.
     */
    if (popupAlreadyShownThisSession()) {
      return;
    }

    try {
      const response = await fetch(
        CONFIG.workerBaseUrl + '/geo',
        {
          method: 'GET',
          mode: 'cors',
          cache: 'no-store'
        }
      );

      if (!response.ok) return;

      const data = await response.json();

      if (
        data &&
        data.ok === true &&
        data.is_brazil === true
      ) {
        showPopup(false);
      }
    } catch (e) {
      /*
       * Geo detection failure should never
       * interfere with normal Global browsing.
       */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();